export const NAV_LINKS = [
  { label: "Blog", href: "/articles" },
  { label: "Cost Guide", href: "/cost-guide" },
  { label: "Experiences", href: "/experiences" },
] as const;
